import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

export const HeaderUser = ({ user, logout, translate }) => {
  const [dropdownUserClass, setUserClass] = useState([
    'dropdown-content',
    'div-perfil',
  ])

  const dropdownRef = useRef()
  const dropdownContainerRef = useRef()

  const handleClick = (e) => {
    const subref = dropdownRef.current.querySelector('#DropdownUser')
    if (dropdownRef.current.contains(e.target)) {
      if (subref.className.indexOf('show') === -1) {
        setUserClass([...dropdownUserClass, 'show'])
      } else {
        if (!dropdownContainerRef.current.contains(e.target)) {
          setUserClass(
            dropdownUserClass.filter((className) => className !== 'show')
          )
        }
      }
    } else {
      setUserClass(
        dropdownUserClass.filter((className) => className !== 'show')
      )
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [])

  const initial = (user || [''])[0]

  const handleLogoutClick = () => {
    logout()
  }

  const onClickClose = () => {
    document.getElementById('DropdownFilial').classList.remove('show')
    setUserClass(dropdownUserClass.filter((className) => className !== 'show'))
  }

  return (
    <div className='w3-all float-right dropdown-a' ref={dropdownRef}>
      <div className='dot'>{initial}</div>
      <div className='display-inline'>
        <p className='p-header title'>{translate('headerUser.hello')}</p>
        <p className='p-header bold'>{user}</p>
      </div>
      <div
        className={`drop-arrow ${
          dropdownUserClass.find((className) => className === 'show')
            ? 'show'
            : ''
        }`}
      />
      <div
        ref={dropdownContainerRef}
        onClick={onClickClose}
        id='DropdownUser'
        className={dropdownUserClass.join(' ')}
      >
        <div onClick={(e) => e.stopPropagation()} className='Usermenu'>
          <a onClick={handleLogoutClick} className='logout color-primary'>
            <svg viewBox='0 0 25 25'>
              <g>
                <g>
                  <path
                    d='M13.84,2.58h-8.4c-0.26,0-0.48,0.21-0.48,0.48v0.27v13.98c0,0.06,0.01,0.12,0.04,0.18c0.01,0.03,0.03,0.05,0.04,0.07
                        c0.02,0.03,0.03,0.06,0.05,0.08l4.56,4.79c0.09,0.1,0.22,0.15,0.35,0.15c0.06,0,0.12-0.01,0.18-0.03c0.18-0.07,0.3-0.25,0.3-0.44
                        V8.04c0-0.12-0.05-0.24-0.13-0.33L6.29,3.53h7.07v13.78c0,0.26,0.21,0.48,0.48,0.48s0.48-0.21,0.48-0.48V3.05
                        C14.32,2.79,14.1,2.58,13.84,2.58z M9.51,20.91l-3.6-3.79V4.51l3.6,3.73V20.91z'
                  />
                  <path
                    d='M19.61,11.2c1.17,0,2.12-0.95,2.12-2.12c0-1.17-0.95-2.12-2.12-2.12c-1.17,0-2.12,0.95-2.12,2.12
                        C17.49,10.25,18.44,11.2,19.61,11.2z M19.61,7.91c0.64,0,1.17,0.52,1.17,1.17c0,0.64-0.52,1.17-1.17,1.17s-1.17-0.52-1.17-1.17
                        C18.44,8.43,18.97,7.91,19.61,7.91z'
                  />
                  <path
                    d='M22.85,11.68c-0.21-0.15-0.43-0.2-0.59-0.22l-5.51,0.01c-0.12,0.02-0.53,0.12-0.8,0.5c-0.15,0.21-0.1,0.51,0.11,0.66
                        c0.21,0.15,0.51,0.1,0.66-0.11c0.05-0.08,0.14-0.11,0.13-0.11l5.32-0.01c0,0,0.07,0.01,0.13,0.06c0.1,0.07,0.15,0.23,0.15,0.47
                        l0,3.42c-0.03,0.17-0.21,0.27-0.52,0.27h-0.86c-0.26,0-0.48,0.21-0.48,0.48l0,3.48c-0.01,0.1-0.1,0.27-0.52,0.27h-0.79l-0.28-0.01
                        l0,0.11c0,0-0.01,0.01-0.01,0.01v-0.12h-0.01l0,0.13c0,0,0,0,0,0v-0.13l-0.08,0c-0.37-0.02-0.43-0.19-0.44-0.26l-0.94,0.11
                        c0.06,0.48,0.44,1.05,1.34,1.1l0.13,0v0l0.29,0.01l0,0c0.01,0,0.01,0,0.02,0h0.79c0.97,0,1.39-0.58,1.47-1.15l0.01-3.08h0.39
                        c0.96,0,1.39-0.58,1.47-1.15l0.01-3.49C23.41,12.23,23.11,11.86,22.85,11.68z M18.98,21.68C18.98,21.68,18.98,21.68,18.98,21.68
                        v0.05V21.68z'
                  />
                </g>
              </g>
            </svg>
            <span>{translate('headerUser.logout')}</span>
          </a>
        </div>
      </div>
      <div className='arrow arrow-perfil color-primary'>
        <svg viewBox='0 0 20 12'>
          <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g
              transform='translate(-346.000000, -567.000000)'
              fill='#000000'
              fillRule='nonzero'
            >
              <g transform='translate(346.000000, 567.000000)'>
                <path d='M1.20888889,0.144654545 L9.55333333,6.11083636 C9.82,6.30174545 10.1811111,6.30283636 10.4477778,6.11301818 L18.7933333,0.190472727 C19.2966667,-0.167345455 20,0.186109091 20,0.795927273 L20,4.08392727 C20,4.32392727 19.8833333,4.54865455 19.6844444,4.68938182 L10.4455556,11.2468364 C10.18,11.4355636 9.82111111,11.4355636 9.55444444,11.2468364 L0.315555556,4.68938182 C0.117777778,4.54865455 0,4.32392727 0,4.08392727 L0,0.749018182 C0,0.137018182 0.705555556,-0.215345455 1.20888889,0.144654545' />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  )
}

HeaderUser.propTypes = {
  user: PropTypes.string.isRequired,
  logout: PropTypes.func,
  translate: PropTypes.func.isRequired,
}

export default HeaderUser
